module.exports = "/_next/static/images/UDJ5-ac82519d80bfd16fc3a92161b3806f1b.svg";